import { render, staticRenderFns } from "./billingDetailAdvert.vue?vue&type=template&id=65ee67bf&scoped=true"
import script from "./billingDetailAdvert.vue?vue&type=script&lang=js"
export * from "./billingDetailAdvert.vue?vue&type=script&lang=js"
import style0 from "./billingDetailAdvert.vue?vue&type=style&index=0&id=65ee67bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee67bf",
  null
  
)

export default component.exports